import React, { useEffect } from "react";
import { Form, Formik } from "formik";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import {
  ModalPageHeader,
  ModalPageBody,
  ModalPageFooter,
  ModalPageWrapper,
  ModalPageHeading,
  ModalPageQuestionDescription,
} from "../../../organisms/ModalPage";
import RadioButtonGroup from "../../../molecules/RadioButtonGroup/RadioButtonGroup";
import { update_signup_form_values } from "../../../../store/actions/signupFlowData";
import { DisabilityRegisterValidationSchema } from "../../../../data/Validation/EligibilityCheckerValidation";
import { DisabilitiesProps } from "./DisabilitiesRoot";
import { pageTitleSuffix } from "../../../../data/eligibilityChecker";

const DisabilityRegister: React.FC<DisabilitiesProps> = (props: DisabilitiesProps) => {
  const { programmeTitle, disabilitiesPageData } = props;

  const dispatch = useDispatch();
  const signupFormValues = useSelector((state: any) => state.signupFlowData.signupFormValues);

  let history = useHistory();
  const pageTitle = `Disabilities | ${programmeTitle} | ${pageTitleSuffix}`;

  useEffect(() => {
    window.gtag("event", "page_view", {
      page_title: pageTitle,
    });
  }, [pageTitle]);

  const handleSubmit = values => {
    history.push(`/disabilities/loading`);
    // Save values to store
    dispatch(update_signup_form_values(values));
  };

  const initialValues = {
    disabilityRegister: signupFormValues?.disabilityRegister ?? "",
  };

  const yesNoOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={DisabilityRegisterValidationSchema}
      validateOnChange={false}
    >
      {({ isSubmitting, values, touched, errors }) => (
        <Form className="eligibility-checker-form disabilities-form">
          <Helmet>
            <title>{pageTitle}</title>
          </Helmet>
          <ModalPageWrapper>
            <ModalPageBody className="with-sticky-footer">
              <ModalPageHeader
                backButtonOnClick={() => {
                  history.goBack();
                }}
              >
                Checking we're a good fit
              </ModalPageHeader>
              <ModalPageHeading>{disabilitiesPageData?.questions[1].question}</ModalPageHeading>
              <ModalPageQuestionDescription>
                {disabilitiesPageData?.questions[1].description}
              </ModalPageQuestionDescription>
              <RadioButtonGroup
                options={yesNoOptions}
                name="disabilityRegister"
                hasErrors={errors["disabilityRegister"] && touched["disabilityRegister"]}
              />
            </ModalPageBody>
            <ModalPageFooter className="sticky-footer">
              <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                Continue
              </Button>
            </ModalPageFooter>
          </ModalPageWrapper>
        </Form>
      )}
    </Formik>
  );
};

export default DisabilityRegister;
